import * as actions from './actions';
import * as getters from './getters';

const module = {
  actions,
  getters,
};

export default { module };
